import { useNavigate } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { CopyText } from '@components/copy-text-field';
import { IconShare } from '@components/icons/share';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { storage } from '@utils/browser';

import { config } from 'app-config';
import { SocialShareButtons } from 'components/ShareJob/SocialShareButtons';
import { Modal } from 'features/modals';
import hiLogo from 'jobboards/hi/hi.png';
import jobDotIsLogo from 'jobboards/jobDotIs/job-dot-is.png';
import tvinnaLogo from 'jobboards/tvinna/tvinna.png';
import { useStore } from 'models/Provider';
import { JOBS_TAB_STORAGE_KEY } from 'pages/Jobs/jobs-config';

function LanguagePublishedModal({ closeModal, job, redirectOnSuccess }) {
  const { current, t } = useStore();
  const navigate = useNavigate();

  const companyName = current.info.name;
  const lang = job.languages[0];
  const urlLang = `${config.CAREERS_URL}/${companyName}/${lang.language}/${job.id}`;
  const urlDirect = `${config.CAREERS_URL}/${companyName}/${job.id}`;
  const url = job.languages.length > 1 ? urlDirect : urlLang;

  function goToDash() {
    closeModal();
    if (redirectOnSuccess) {
      storage.set(JOBS_TAB_STORAGE_KEY, '0');
      navigate('/');
    }
  }

  function goToJobBoards() {
    closeModal();
    if (redirectOnSuccess) {
      navigate(`/jobs/${job.id}/promote/new`);
    }
  }

  return (
    <Modal>
      <Stack space={0}>
        <Modal.Header text={t('job.create.publish.modal.title') + ' 🎉'} />
        <Text color="purple80" text={t('job.create.publish.modal.tagline')} />
      </Stack>
      <Separator />
      <Stack space={4}>
        <Stack space={0}>
          <Text font="heading2" text={t('job.create.publish.modal.publishjob.title')} />
          <Text color="purple80" text={t('job.create.publish.modal.jobboard.tagline')} />
        </Stack>
        <Stack orientation="horizontal" align="center" justify="space-between">
          <div>
            <Stack space={2} orientation="horizontal" align="center">
              <img height={40} src={tvinnaLogo} alt="Tvinna" />
              <img height={40} src={jobDotIsLogo} alt="Job.is" />
              <img height={40} src={hiLogo} alt="Tengslanet hi" />
            </Stack>
          </div>
          <Button
            text={t('job.create.publish.modal.jobboard.button')}
            iconLeft={<IconShare />}
            onClick={goToJobBoards}
          />
        </Stack>
      </Stack>
      <Separator />
      <CopyText
        copyText={t('copy.button.text')}
        copiedText={t('copy.button.copied')}
        label={t('sharejob.copy.header.direct')}
        value={url}
      />
      <Separator />
      <Text font="heading2" text={t('sharejob.header.sharing.title')} />
      <SocialShareButtons url={url} />
      <Modal.Actions>
        <Button
          dataCy="close-publish-modal"
          variant="secondary"
          onClick={goToDash}
          text={t('sharejob.modal.close')}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(LanguagePublishedModal);
